/* hgn-recorder.js v2026-10-23.1 (contract v1.3.2): the site-wide behaviour recorder (our own Clarity, joined to orders).
   Contract: redesigned/RECORDER-CONTRACT-SITE-2026-10-19.md (v1.1, §7 for v1.2 and v1.3). Paste: redesigned/SITE-RECORDER-PASTE-2026-10.md.
   Loaded deferred by snippets/hgn-recorder.liquid (layout/theme.liquid, end of body) on every theme page except the theme
   editor and /account. Kill switch + sampling: Theme settings > Behaviour recorder.
   - The Meta landing (collection.meta with an arm) is recorded EXACTLY as hgn-lp-recorder.js v2026-10-18.1 records it
     (same tokens, exp/arm/variant, 15 s cadence): the v1 maps below are frozen. If the legacy tag (script[data-hgn-lprec])
     is on the page, the legacy recorder owns the landing and this one stays out.
   - Every other page: page = home|collection|pdp|cart|search|page|blog|other, exp/arm/variant omitted, handle + tpl added,
     a send at 5 s, then every 30 s only when the state changed, on hide and on pagehide (final).
   - v2026-10-20.1 (dead-tap read, _golive-2026-10-deadtaps-speed/PASTE.md), SITE PAGES ONLY (the landing's v1
     classification and labels stay frozen for its A/B read): things that work through a script count as working taps:
     a <video>/<audio> with native controls (video_ctl), the quick view's scrim (qv_close), anything carrying a quick-view
     handle (its delegated listener opens it), the open menu's scrim (menu_close), any [data-hgn-scrim] backdrop and any
     [data-hgn-tap="<label>"] element the theme marks; in the side cart, quick-view taps read qv_open and the kit's
     picture cart_kit_open. A dead or rage tap carries the tapped element's first class token in v (a code
     token, never text), so a hotspot names its own element.
   - v2026-10-21.1 (contract v1.3, _golive-2026-10-21c-recorder13), SITE PAGES ONLY (the landing is untouched: same
     tokens, maps, visibility, cadence and payload):
     · what made the slowest tap slow: inp_l (the label of the recorded tap nearest the worst interaction, within 1 s),
       inp_s (the longest script in the long animation frames overlapping it, as a file token such as hgn-kit-bar.js;
       inline for page scripts; render when the frame ran no script) and inp_fl (that script's forced style/layout ms).
       inp_s/inp_fl only where the browser has long-animation-frame timing (Chrome); never on WebKit.
     · what jumped: for the largest single layout shift, cls_src (its largest moved element's first class token, as a
       dead tap's v), cls_dy (px it moved down, − = up), cls_t (ms since load) and cls_y (scrollY when it was seen).
     · cheaper visibility: one IntersectionObserver per section with the one threshold where the rule (≥50% of it in
       view, or ≥30% of the viewport) flips, re-armed when its size or the viewport changes; no layout reads each
       second; rescans only after elements are added (≤ every 2 s); the 1 s bookkeeping runs in idle time.
   - v2026-10-23.1 (contract v1.3.2, _golive-2026-10-23-recorder132): on hide and pagehide, entries the browser has
     queued but not yet delivered (layout-shift, then long-animation-frame, then event) are drained through their own
     callbacks before the send (the web-vitals pattern; site pages only, the landing stays frozen), so a slow tap that leaves the page still counts in inp and
     carries its attribution. When no recorded tap lies within 1 s of the worst interaction (a tap made before this
     script loaded), inp_l falls back to the label of the interaction's own target (Event Timing's entry.target, labelled
     when the entry arrives). INP, inp_l coverage and the slow-tap shares step up from this version's paste: read across
     it, never through it. On the homepage the tag loads async (snippets/hgn-recorder.liquid), so it no longer waits behind the
     page's other deferred scripts. Payload, pv, seq, consent and the landing's behaviour are unchanged.
   Records NOTHING until Shopify.customerPrivacy.analyticsProcessingAllowed() is true; with no consent it never sends.
   Tokens only: no text, no typed values or search terms, no keystrokes, no coordinates, no personal data. Never throws. ES5. */
(function (W, D) {
  'use strict';
  function main() {
    if (!D || !D.documentElement || W.__hgnRec) return;
    var H = D.documentElement, N = W.navigator || {}, L = W.location, P = W.performance;
    function T() { try { return Math.round(P.now()); } catch (e) { return 0; } }
    function sf(f) { return function () { try { return f.apply(this, arguments); } catch (e) {} }; }
    function cl(e, s) { try { return e && e.closest ? e.closest(s) : null; } catch (x) { return null; } }
    function mt(e, s) { try { return !!(e && e.matches && e.matches(s)); } catch (x) { return false; } }
    function at(e, a) { return (e && e.getAttribute && e.getAttribute(a)) || ''; }
    function on(t, n, f, o) { try { t.addEventListener(n, f, o || false); } catch (e) {} }
    function qa(s) { try { return D.querySelectorAll(s); } catch (e) { return []; } }
    function shown(e) { return !!(e && e.getClientRects && e.getClientRects().length); }
    /* 'tok:selector|tok:selector' → [[tok, selector], …] (a token never holds a colon; the first one splits) */
    function map(s) { return s.split('|').map(function (x) { var i = x.indexOf(':'); return [x.slice(0, i), x.slice(i + 1)]; }); }

    var SC = D.currentScript || D.querySelector('script[data-hgn-rec]');
    var ARM = at(H, 'data-hgn-arm-lp');
    var LPM = at(SC, 'data-lp') === '1' && /^[ABC]$/.test(ARM); /* the Meta landing: v1, frozen */
    /* the landing's own switches: the legacy tag (rollback) owns it; the section's "off" marker stops it */
    if (LPM && D.querySelector('script[data-hgn-lprec],[data-hgn-rec-off]')) return;
    W.__hgnRec = 1;
    var PAGE = LPM ? 'lp' : at(SC, 'data-page') || 'other';
    var LP = W.__hgnLp || {};
    var EXP = String(LP.exp || at(SC, 'data-exp')), KEY = String(LP.key || at(SC, 'data-key'));
    var COLL = at(SC, 'data-coll') || (/\/collections\/([a-z0-9-]+)/.exec(L.pathname) || [])[1] || '';
    var HANDLE = at(SC, 'data-handle'), TPL = at(SC, 'data-tpl').toLowerCase().replace(/-/g, '_').slice(0, 24);
    if (!/^[a-z0-9-]{1,120}$/.test(HANDLE)) HANDLE = '';
    if (!/^[a-z][a-z0-9_]{0,23}$/.test(TPL)) TPL = '';
    var SAMPLE = parseInt(at(SC, 'data-sample'), 10);
    if (isNaN(SAMPLE)) SAMPLE = 100;
    var EP = 'https://track.holygrailnail.com/r';
    var EVERY = Math.max(1000, (LPM ? +W.HGN_LPREC_MS : +W.HGN_REC_MS) || (LPM ? 15000 : 30000));
    var UA = N.userAgent || '';

    /* ── Clarity tags, the landing only (as hgn-lp-recorder.js): every arm, whatever our gate says. Never defines
       window.clarity: the popup's loader skips Clarity when it already exists. ── */
    if (LPM) {
      var clOK = 0;
      var clar = sf(function () {
        if (clOK || typeof W.clarity !== 'function') return;
        clOK = 1;
        W.clarity('set', 'lp_arm', ARM);
        if (KEY) W.clarity('set', 'lp_concept', KEY);
        if (COLL) W.clarity('set', 'lp_coll', COLL);
      });
      var clLater = function () { setTimeout(clar, 0); };
      clar();
      if (!clOK) {
        on(W, 'load', clLater);
        ['pointermove', 'touchstart', 'scroll', 'keydown'].forEach(function (n) { on(W, n, clLater, { once: true, passive: true, capture: true }); });
        on(D, 'visitorConsentCollected', clLater);
        var clN = 0, clI = setInterval(function () { clar(); if (clOK || ++clN >= 300) clearInterval(clI); }, 2000);
      }
    }

    /* ── state ── */
    var REC = 0, GONE = 0, C0 = -1, SEQ = 0, SENDS = 0, PV = '', LASTSIG = '';
    var SEC = {}, VIS = {}, SCR = 0, MAXY = 0, TILES = 0, TAPS = [], NT = 0, TTFT = -1, TOP = 0, EXIT = 'none', OUT = 'none';
    var KS = 0, KP = 0, ATC = 0, LCP = -1, CLS = -1, INP = -1;
    /* v1.3, site pages only: the recorded taps' times [down, up, label]; the worst interaction [start, end]; the long
       animation frames seen [start, end, best script]; the worst interaction's script; the largest shift's source */
    var TT = [], IW = null, LF = [], INPS = '', INPD = -1, INPFL = -1, CLSBIG = 0, CLSS = '', CLSDY = null, CLST = -1, CLSY = -1;
    var NV = !LPM && !!(W.IntersectionObserver && W.ResizeObserver); /* the observer-driven visibility (else the 1 s calc) */
    var lastT = T(), visible = D.visibilityState !== 'hidden', lastNav = null, lastTapT = -1e9, lastAdd = -1e9, lastSS = -1e9;
    if (visible) TOP = lastT;
    try { PV = W.crypto && W.crypto.randomUUID ? W.crypto.randomUUID() : ''; } catch (e) {}
    if (!PV) PV = 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
    /* QA: a pinned arm, a theme preview, or (off the landing) a harness browser: the worker drops these rows */
    var PIN = /[?&](hgn_lp_arm|preview_theme_id)=/.test(L.search) || /shopifypreview\.com$/.test(L.hostname) || LP.qa ? 1 : 0;
    var IAB = /Instagram/i.test(UA) ? 'instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A|MessengerForiOS/i.test(UA) ? 'facebook'
      : /musical_ly|BytedanceWebview|TikTok|trill_/i.test(UA) ? 'tiktok' : /; wv\)|Snapchat|Pinterest|Twitter|LinkedInApp|Line\/|GSA\//i.test(UA) ? 'other' : 'none';
    if (!LPM && /HGNApp/.test(UA)) IAB = 'app'; /* our own app (hgn-app-detect's token) */
    var OS = /iPhone|iPad|iPod/.test(UA) || (/Macintosh/.test(UA) && N.maxTouchPoints > 1) ? 'ios' : /Android/.test(UA) ? 'android' : 'other';

    /* ── sections. Order = priority for a tap's section: overlays, sub-areas, then sections. ── */
    var popupO = ['popup', '#hgn-popup', function (e) { return e.classList.contains('is-open'); }, 1];
    var cartO = ['sidecart', '#hgn-side-cart', function (e) { return !e.hidden && at(e, 'aria-hidden') !== 'true'; }, 1];
    var qvO = ['pdp_quick', '[data-hgn-qv-root]', function (e) { return !e.hidden; }, 1];
    var barO = ['kitbar', '[data-hgn-kit-bar]', function (e) { return !e.hidden; }, 0];
    /* Dawn's facets drawer (facets.liquid): its open panel only */
    var drawerO = function (k) { return [k, 'menu-drawer.mobile-facets__wrapper', function (e) { return !!e.querySelector('details.mobile-facets__disclosure[open]'); }, 1, 'menu-drawer details[open] > :not(summary)']; };
    var OV, PG, GRIDS, GRID = '.hgn-bestsellers__grid,#product-grid,.hgn-kit-rail__row';
    if (LPM) { /* v1 (hgn-lp-recorder.js), frozen */
      OV = [popupO, cartO,
        ['lpf_drawer', '[data-hgn-lpf-drawer]', function (e) { return !!e.querySelector('details[open]'); }, 1],
        ['howto_sheet', '[data-hgn-lp-sheet]', function (e) { return !e.hidden; }, 1], qvO, barO];
      if (ARM === 'A') OV.splice(3, 0, drawerO('a_drawer'));
      PG = map(ARM === 'A'
        ? 'a_kitrow:.hgn-coll-kit-group .hgn-ckit-chip,.hgn-coll-kit-group .hgn-ckit-rail|a_kitstrip:.hgn-coll-kit-group|a_filters:[data-hgn-coll-tier1],#main-collection-filters|' +
          'a_hero:[id$="__lpa-hero"]|a_grid:[id$="__lpa-grid"] #product-grid|a_seo:[id$="__lpa-seo"]'
        : 'b_proof:[id$="__lpb-hero"] .hgn-lp-proof|b_howto:[data-hgn-lp-chips]|b_pills:[id$="__lpb-edit"] .hgn-bestsellers__pillrow|b_kitcard:[data-hgn-lp-kitstrip]|' +
          'b_filters:[data-hgn-lpf-panel]|b_more:[id$="__lpb-edit"] .hgn-bestsellers__load-more-wrap,[data-hgn-lpf-results] [data-hgn-lp-feed-handle]|b_results:[data-hgn-lpf-results]|' +
          'b_grid:[id$="__lpb-edit"] [data-hgn-bs-panel]:not([data-hgn-lpf-results])|b_hero:[id$="__lpb-hero"]|b_press:[id$="__lpb-proof"]|b_kits:[id$="__lpb-kits"]|' +
          'b_ranges:[id$="__lpb-ranges"]|b_reviews:[id$="__lpb-reviews"]|b_founder:[id$="__lpb-founder"]|b_quiz:[id$="__lpb-quiz"]')
        .concat(map('announce:section.hgn-announce|header:.hgn-header|footer:[id*="__hgn_footer"]'));
      GRIDS = ARM === 'A' ? '[id$="__lpa-grid"] #product-grid > li' : '[id$="__lpb-edit"] .hgn-bestsellers__grid > *';
    } else { /* v1.1: the site's page types (section maps from the live templates, 19 Oct) */
      OV = [popupO, cartO, drawerO('facets_drawer'), ['pdp_zoom', 'product-modal', function (e) { return e.hasAttribute('open'); }, 1], qvO, barO];
      var pm = {
        home: 'home_hero:.hgn-hero-section|home_press:.hgn-marquee-section|home_ranges:.hgn-quick-links-section|home_quiz:.hgn-quiz-section|home_best:.hgn-bestsellers-section|' +
          'home_kits:.hgn-kit-rail-section|home_ritual:.hgn-ritual-section|home_drop:.hgn-drop-teaser-section|home_founder:.hgn-founder-section|home_reviews:.hgn-reviews-section|' +
          'home_points:.hgn-nail-points-section',
        collection: 'coll_kitrow:.hgn-coll-kit-group .hgn-ckit-chip,.hgn-coll-kit-group .hgn-ckit-rail|coll_kitstrip:.hgn-coll-kit-group|' +
          'coll_filters:[data-hgn-coll-tier1],#main-collection-filters,.facets-wrapper|coll_hero:.hgn-collection-hero|coll_grid:#product-grid|coll_seo:.hgn-cseo',
        pdp: 'pdp_sticky:.hgn-buy-sticky|pdp_kit:.hgn-pdp-kit|pdp_options:variant-selects,variant-radios,.product-form__quantity|pdp_buy:.hgn-buy|pdp_ai:.hgn-ai-hook|' +
          'pdp_howto:.hgn-app-pill,[data-hgn-app-vid]|pdp_trust:.hgn-trust-perf,.hgn-trust-promise,.hgn-we-say,.hgn-style-it-up,.hgn-ctl-card|pdp_info:.hgn-pdp-title,.hgn-pdp-spec,.hgn-price,#hgn-global-stars-trigger|' +
          'pdp_upsell:.hgn-pdp-content__upsells|pdp_details:[data-hgn-pdp-content-piece],.hgn-pdp-content-source|pdp_gallery:media-gallery|pdp_reviews:.hgn-product-reviews|' +
          'pdp_recs:.related-products',
        cart: 'cart_kit:[data-hgn-cart-page-bundle]|cart_shipbar:[data-hgn-cart-page-shipbar]|cart_offers:[data-hgn-cart-page-panels]|cart_lines:[data-hgn-cart-page-items]|' +
          'cart_summary:[data-hgn-cart-page-summary]|cart_empty:.hgn-cart-page__empty|cart_head:.hgn-cart-page__head',
        search: 'search_chips:[data-hgn-sb-chips]|search_bar:.hgn-search-bar|search_supp:.hgn-search-supplement|search_tabs:[data-hgn-tabs]|' +
          'search_filters:[data-hgn-coll-tier1],.hgn-search-grid .facets-wrapper|search_grid:.hgn-search-grid__grid'
      }[PAGE];
      PG = map((pm ? pm + '|' : '') + 'app_bar:.hgn-app-tab-bar|announce:section.hgn-announce|header:.hgn-header|crumbs:.hgn-breadcrumbs|footer:[id*="__hgn_footer"]');
      GRIDS = { home: '.hgn-bestsellers-section .hgn-bestsellers__grid > *', collection: '#product-grid > li', search: '.hgn-search-grid__grid > *', pdp: '.related-products .grid > *' }[PAGE] || '';
      GRID += ',.hgn-search-grid__grid,.related-products .grid';
    }

    function secOf(e) {
      var i, o;
      for (i = 0; i < OV.length; i++) { o = OV[i]; if (cl(e, o[4] || o[1])) return o[0]; }
      for (i = 0; i < PG.length; i++) if (cl(e, PG[i][1])) return PG[i][0];
      return !LPM && cl(e, '#MainContent') ? 'main' : 'none';
    }

    /* ── tap labels: [selector, label, value/index fn or a fixed value]. First rule whose closest() matches wins. ── */
    var TILE = '.card-wrapper,[data-hgn-kit-placed],[data-hgn-lpf-shell],.grid__item,.hgn-kit-rail__card';
    function slug(s) {
      s = String(s || '').toLowerCase().replace(/[^a-z0-9_:.-]+/g, '-').replace(/-+/g, '-').replace(/^[^a-z0-9]+/, '').slice(0, 40);
      return /^[a-z0-9][a-z0-9_:.-]{0,39}$/.test(s) ? s : '';
    }
    function tileOf(e) { var g = cl(e, GRID); if (!g) return null; while (e && e.parentNode !== g) e = e.parentNode; return e; }
    function nth(t, sel) {
      if (!t || !t.parentNode) return 0;
      for (var n = 0, c = t.parentNode.firstElementChild; c; c = c.nextElementSibling) {
        if (mt(c, sel) && shown(c)) n++;
        if (c === t) return n;
      }
      return 0;
    }
    function tier(e) {
      var c = cl(e, '[data-hgn-kit-tier],[data-tier]'), k = cl(e, '.hgn-card'), v = at(c, 'data-hgn-kit-tier') || at(c, 'data-tier');
      if (!/^(press-ons|gels|classic)$/.test(v) && k) v = at(k.querySelector('.wishlist-card-button[data-tier],[data-hgn-card-kit][data-tier]'), 'data-tier');
      return /^(press-ons|gels|classic)$/.test(v) ? v : '';
    }
    function vTile(e) { return { i: nth(tileOf(e), TILE), v: tier(e) }; }
    function vx(sel, a, n) { return function (e) { var x = cl(e, sel); return { i: n ? nth(x, sel) : 0, v: a === 'href' ? range(at(x, a)) : slug(at(x, a)) }; }; }
    function range(h) {
      h = String(h || '');
      return /press-on/.test(h) ? 'press-ons' : /gel-nail|\/gels/.test(h) ? 'gels' : /classic|manicure-wrap/.test(h) ? 'classic'
        : /pedicure/.test(h) ? 'pedicure' : /starter-kit/.test(h) ? 'kits' : /collections\/all/.test(h) ? 'all' : '';
    }
    function fkey(p) { var m = /([a-z0-9_]+)$/.exec(String(p || '').toLowerCase()); return m ? m[1] : ''; }
    function vChip(e) {
      var x = cl(e, '[data-hgn-lpf-chip],[data-hgn-tier1-chip]'), lp = x && x.hasAttribute('data-hgn-lpf-chip');
      var k = fkey(at(x, lp ? 'data-hgn-lpf-param' : 'data-hgn-tier1-param')), v = at(x, lp ? 'data-hgn-lpf-value' : 'data-hgn-tier1-value');
      return { i: nth(x, lp ? '[data-hgn-lpf-chip]' : '[data-hgn-tier1-chip]'), v: k ? slug(k + ':' + v) : '' };
    }
    function vOpt(e) {
      var lab = cl(e, 'label'), inp = mt(e, 'input') ? e : lab && (lab.control || lab.querySelector('input'));
      if (!inp || !/^(checkbox|radio)$/.test(inp.type)) return { v: '' }; /* never a typed value */
      var k = fkey(inp.name);
      return { v: k ? slug(k + ':' + inp.value) : '' };
    }
    function vGroup(e) { var d = cl(e, 'details'); var m = /filter\.[a-z]\.(?:[a-z0-9_]+\.)*([a-z0-9_]+)/.exec(at(d, 'id')); return { v: m ? slug(m[1]) : '' }; }
    function vMore(e) {
      var b = cl(e, '[data-hgn-bs-reveal],[data-hgn-lp-feed-handle],.hgn-bestsellers__load-more'), p = cl(b, '[data-hgn-bs-panel]');
      return { v: p && p.querySelector('[data-hgn-bs-more][hidden]') ? '0' : (at(b, 'data-hgn-lp-feed-next') || '1') };
    }
    function lKit(e) {
      var k = cl(e, '[data-hgn-kit-placed-kind]'), g = cl(e, '[data-hgn-kit-gateway]');
      var shell = cl(e, '[data-hgn-lpf-shell]') || (k ? at(k, 'data-hgn-kit-placed-kind') === 'shell' : (at(g, 'data-shell') === 'true' || !!(g && g.querySelector('[data-hgn-collage-shell]'))));
      return shell ? 'kit_tile' : 'kit_edit_tile';
    }
    /* a PDP option: v = the option's name key (size, shape…) from the input's name, never free text */
    function vVar(e) {
      var lab = cl(e, 'label'), inp = mt(e, 'input,select') ? e : lab && (lab.control || lab.querySelector('input'));
      return { v: slug(fkey(String(at(inp, 'name')).replace(/[\]\s]+/g, '_').replace(/_+$/, ''))) };
    }
    function nthOf(sel) { return function (e) { var x = cl(e, sel); return { i: nth(x, sel) }; }; }
    var LB = [ /* v1 (hgn-lp-recorder.js), frozen: the landing uses only these */
      ['[data-hgn-popup-close],[data-hgn-popup-teaser-close],[data-hgn-popup-reminder-close]', 'popup_close'],
      ['#hgn-popup [data-goal]', 'popup_goal', vx('[data-goal]', 'data-goal')],
      ['[data-hgn-popup-submit],[data-rf-submit-btn]', 'popup_submit'],
      ['[data-hgn-side-cart-checkout],[data-hgn-side-cart-kit-cta],[data-hgn-express-regular]', 'cart_checkout'],
      ['[data-hgn-express-open],[data-hgn-express-wallets],shopify-accelerated-checkout-cart', 'express_pay'],
      ['[data-hgn-side-cart-close],[data-hgn-side-cart-scrim]', 'cart_close'],
      ['[data-hgn-side-cart-upsell]', 'cart_upsell'],
      ['[data-hgn-kit-bar-view]', 'kitbar_checkout'],
      ['[data-hgn-kit-bar-status]', 'kitbar_open'],
      ['[data-hgn-kit-bar-switch]', 'kit_toggle'],
      ['.hgn-qv-trigger', 'qv_open'],
      ['[data-hgn-lp-sheet-shop],[data-hgn-lp-sheet-range]', 'howto_shop', vx('[data-hgn-lp-sheet-range]', 'data-hgn-lp-sheet-range')],
      ['[data-hgn-lp-sheet-close]', 'howto_close'],
      ['[data-hgn-drawer-close]', 'drawer_close'],
      ['.mobile-facets__clear,.mobile-facets__clear-wrapper', 'filter_clear'],
      ['.mobile-facets__footer .button,.mobile-facets__footer [type=submit]', 'drawer_apply'],
      ['.mobile-facets__list label,.mobile-facets__list input', 'drawer_option', vOpt],
      ['.mobile-facets__sort,.mobile-facets__sort select', 'filter_sort'],
      ['.mobile-facets__open-wrapper', 'filter_open'],
      ['.mobile-facets__summary', 'drawer_group', vGroup],
      ['.hgn-header__menu-trigger', 'hdr_menu'],
      ['.hgn-header__logo', 'hdr_logo'],
      ['[data-hgn-search-toggle],.hgn-header__search-strip', 'hdr_search'],
      ['.wishlist-header-wrapper', 'hdr_wish'],
      ['[data-hgn-cart-trigger]', 'hdr_cart'],
      ['.hgn-header__nav-link,.hgn-header__mobile-link', 'nav_link', vx('.hgn-header__nav-link,.hgn-header__mobile-link', 'href', 1)],
      ['.hgn-hero__ctas a', 'hero_cta'],
      ['.hgn-hero__image,.hgn-hero__img', 'hero_img'],
      ['.hgn-hero__headline', 'hero_headline'],
      ['.hgn-lp-proof__face,[data-hgn-lp-faces]', 'proof_faces'],
      ['.hgn-lp-proof__l2,.hgn-hero__trust,.hgn-lp-offer', 'trust_line'],
      ['.hgn-lp-proof', 'proof_stars'],
      ['[data-hgn-lp-chip="how-to-apply"]', 'howto_open'],
      ['[data-hgn-lp-chip]', 'howto_chip', vx('[data-hgn-lp-chip]', 'data-hgn-lp-chip', 1)],
      ['[data-hgn-lpf-open]', 'filter_open'],
      ['[data-hgn-lpf-range]', 'range_pill', vx('[data-hgn-lpf-range]', 'data-hgn-lpf-range', 1)],
      ['[data-hgn-bs-tab]', 'range_pill', vx('[data-hgn-bs-tab]', 'data-hgn-bs-tab', 1)],
      ['[data-hgn-lpf-active] a,[data-hgn-lpf-active] button,.active-facets a', 'filter_remove'],
      ['[data-hgn-lpf-clear],.hgn-coll-clear-all', 'filter_clear'],
      ['[data-hgn-lpf-sort],.hgn-coll-sort-toggle,.facet-filters__sort', 'filter_sort'],
      ['[data-hgn-lpf-chip],[data-hgn-tier1-chip]', 'filter_chip', vChip],
      ['[data-hgn-lp-kitstrip-switch]', function (e) { return at(cl(e, '[data-hgn-lp-kitstrip-switch]'), 'aria-pressed') === 'true' ? 'kitcard_stop' : 'kitcard_start'; }, vx('[data-hgn-lp-kitstrip]', 'data-hgn-lp-kitstrip')],
      ['[data-hgn-coll-kit-help]', 'kit_help'],
      ['[data-hgn-coll-kit-toggle],.hgn-coll-kit-seg', 'kit_toggle'],
      ['.hgn-ckit-chip', 'kitrow_view', vx('.hgn-ckit-chip', 'data-hgn-ckit-view')],
      ['[data-hgn-kr-tab]', 'kitrail_tab', vx('[data-hgn-kr-tab]', 'data-hgn-kr-tab')],
      ['.hgn-kit-rail__card', 'kitrail_card', vx('.hgn-kit-rail__card', '', 1)],
      ['[data-hgn-kit-placed],[data-hgn-lpf-shell],[data-hgn-kit-gateway]', lKit, vTile],
      ['.hgn-card__quickadd.is-kit-takeover,[data-hgn-card-kit]', 'kit_pick', vTile],
      ['.hgn-card__wishlist,.wishlist-card-button', 'card_wish', vTile],
      ['.hgn-card__quickadd,.quick-add__submit', 'card_add', vTile],
      ['.image-cycling-indicators,.image-cycling-arrow', 'card_swipe', vTile],
      ['.hgn-card__media,.card__media', 'card_img', vTile],
      ['.hgn-card__name', 'card_name', vTile],
      ['.hgn-card__price,.hgn-card .price', 'card_price', vTile],
      ['.hgn-card', 'card_body', vTile],
      ['[data-hgn-bs-reveal],[data-hgn-lp-feed-handle],.hgn-bestsellers__load-more', 'load_more', vMore],
      ['.hgn-marquee__logo,.hgn-marquee__pub,.hgn-marquee__stat', 'press_logo'],
      ['.hgn-quick-link', 'range_tile', vx('.hgn-quick-link', 'href', 1)],
      ['.hgn-review-card', 'review_card', vx('.hgn-review-card', '', 1)],
      ['.hgn-reviews__foot a,[id$="__lpb-reviews"] .hgn-link-underline', 'reviews_all'],
      ['.hgn-founder__cta', 'founder_cta'],
      ['.hgn-quiz__cta,[data-hgn-quiz-open]', 'quiz_cta'],
      ['[data-hgn-collection-hero-toggle]', 'a_readmore'],
      ['[id*="__hgn_footer"] a', 'footer_link']
    ];
    /* v1.1: the site's own elements, checked before the v1 rules (never on the landing) */
    if (!LPM) LB = [
      /* carts (side cart and /cart) */
      ['[data-hgn-side-cart-action="inc"],[data-hgn-cart-page-qty-inc]', 'cart_qty', 'inc'],
      ['[data-hgn-side-cart-action="dec"],[data-hgn-cart-page-qty-dec]', 'cart_qty', 'dec'],
      ['[data-hgn-side-cart-action="remove-bundle"],[data-hgn-cart-page-bundle-remove]', 'cart_remove', 'kit'],
      ['[data-hgn-side-cart-action="remove"],[data-hgn-cart-page-line-remove]', 'cart_remove', 'line'],
      ['[data-hgn-cart-page-checkout]', 'cart_checkout'],
      ['[data-hgn-cart-page-adhoc],[data-hgn-side-cart-adhoc-toggle],[data-hgn-side-cart-adhoc-summary],[data-hgn-side-cart-adhoc-body]', 'cart_code'],
      ['[data-hgn-cart-page-beans],[data-hgn-side-cart-beans]', 'cart_points'],
      ['#hgn-side-cart .hgn-side-cart__bundle-thumb[data-hgn-side-cart-action]', 'cart_kit_open'],
      ['#hgn-side-cart [data-hgn-qv-handle]', 'qv_open'],
      ['[data-hgn-qv-scrim]', 'qv_close'],
      ['[data-hgn-tap]', function (e) { return slug(at(cl(e, '[data-hgn-tap]'), 'data-hgn-tap')) || 'tap'; }],
      ['video[controls],audio[controls]', 'video_ctl'],
      /* search: the header panel and /search (never a term: chips and suggestions carry no value) */
      ['[data-hgn-search-item],.hgn-header__search-product', 'search_result', nthOf('[data-hgn-search-item],.hgn-header__search-product')],
      ['.hgn-header__search-suggestion', 'search_suggest'],
      ['[data-hgn-search-input],.hgn-sb__input', 'search_input'],
      ['.hgn-sb__submit,.hgn-header__search-form [type=submit]', 'search_submit'],
      ['.hgn-sb__chip', 'search_chip', nthOf('.hgn-sb__chip')],
      ['.hgn-search-grid__tab', 'search_tab', vx('.hgn-search-grid__tab', 'data-hgn-tab', 1)],
      /* the PDP (dead taps on its title, price, trust and stars take the section token) */
      ['.hgn-buy__submit.is-kit-takeover,[data-hgn-buy-sticky-cta].is-kit-takeover', 'pdp_kit_add'],
      ['[data-hgn-buy-submit],.product-form__submit,[data-hgn-buy-sticky-cta]', 'pdp_atc'],
      ['[data-hgn-notify-submit]', 'pdp_notify'],
      ['[data-hgn-buy-wish]', 'pdp_wish'],
      ['.quantity__button[name=plus]', 'pdp_qty', 'inc'],
      ['.quantity__button', 'pdp_qty', 'dec'],
      ['variant-selects,variant-radios', 'pdp_variant', vVar],
      ['media-gallery .slider-button', 'pdp_gallery_nav'],
      ['.thumbnail-list__item', 'pdp_thumb', nthOf('.thumbnail-list__item')],
      ['.product__modal-opener,.product__media-toggle', 'pdp_zoom', nthOf('.product__media-item')],
      ['.hgn-ai-hook', 'ai_hook'],
      ['[data-hgn-av-prev],[data-hgn-av-next],[data-hgn-av-dot],[data-hgn-av-step]', 'howto_nav'],
      ['.hgn-app-pill,[data-hgn-app-pill]', 'app_pill'],
      ['[data-hgn-pdp-content-atc]', 'pdp_upsell_add'],
      ['.hgn-pdp-content__row-summary', 'pdp_row', function (e) { return { v: slug(at(cl(e, '[data-hgn-pdp-content-piece]'), 'data-content-type')) }; }],
      ['#hgn-global-stars-trigger', 'review_stars'],
      ['[data-hgn-pr-write]', 'reviews_write'],
      ['[data-hgn-pr-more]', 'reviews_more'],
      ['.hgn-product-reviews__list > *', 'review_card', nthOf('.hgn-product-reviews__list > *')],
      /* the homepage */
      ['.hgn-hero__ctas .hgn-btn-ghost', 'hero_ghost'],
      ['[data-tier-tab]', 'ritual_tab', nthOf('[data-tier-tab]')],
      ['.hgn-ritual__cta', 'ritual_cta', vx('.hgn-ritual__cta', 'data-hgn-ritual-tier')],
      ['[data-tier-prev],[data-tier-next],[data-tier-dot],[data-tier-step]', 'ritual_nav'],
      ['.hgn-drop-flag__card', 'drop_card', vx('.hgn-drop-flag__card', 'data-hgn-drop-teaser-tier', 1)],
      ['.hgn-drop-flag__cta', 'drop_cta'],
      ['.hgn-nail-points__cta', 'points_cta'],
      ['.hgn-bestsellers__head a', 'best_all'],
      ['.hgn-kit-rail__all', 'kitrail_all', vx('.hgn-kit-rail__all', 'href')],
      /* collections, and our app's tab bar */
      ['[data-hgn-collection-hero-toggle]', 'coll_readmore'],
      ['[data-hgn-card-drop]', 'drop_pick', vTile],
      ['.hgn-app-tab-bar__tab', 'app_tab', vx('.hgn-app-tab-bar__tab', 'data-hgn-tab')]
    ].concat(LB);
    var INTER = 'a,button,input,select,textarea,label,summary,[role=button],[role=tab],[role=link],[role=checkbox],[role=switch],[tabindex]:not([tabindex^="-"]),' +
      '[data-hgn-lp-sheet-close],[data-hgn-side-cart-scrim],[data-hgn-kit-swap-cancel],[data-hgn-kit-focus-cancel],[data-hgn-kit-off-cancel]';
    var BACKDROP = 'form.mobile-facets,details.mobile-facets__disclosure[open]';
    /* v2026-10-20.1, site pages only: script-driven controls count as interactive; a scrim counts only when it is the
       element tapped (the open menu's root IS its scrim: a tap inside the panel lands on the panel, not the root) */
    var SCRIM = '';
    if (!LPM) {
      INTER += ',video[controls],audio[controls],[data-hgn-qv-scrim],[data-hgn-qv-handle],[data-hgn-tap]';
      SCRIM = '.hgn-header__mobile.is-open,[data-hgn-scrim]';
    }
    var NAVL = { cart_checkout: 1, express_pay: 1, search_submit: !LPM };

    function label(e, swipe) {
      var r = { l: '', i: 0, v: '' }, j, x, o;
      if (swipe === 2) { r.l = 'pdp_gallery_swipe'; return r; }
      if (swipe) { o = vTile(e); r.l = 'card_swipe'; r.i = o.i; r.v = o.v; return r; }
      if (mt(e, BACKDROP)) { r.l = 'drawer_close'; return r; }
      if (SCRIM && mt(e, SCRIM)) { r.l = slug(at(e, 'data-hgn-scrim')) || 'menu_close'; return r; }
      for (j = 0; j < LB.length; j++) {
        x = LB[j];
        if (!cl(e, x[0])) continue;
        r.l = typeof x[1] === 'function' ? x[1](e) : x[1];
        o = typeof x[2] === 'function' ? x[2](e) || {} : { v: x[2] };
        r.i = o.i || 0; r.v = o.v || '';
        return r;
      }
      x = cl(e, INTER);
      r.l = !x ? '' : mt(x, 'a[href]') ? 'other_link' : 'other_button';
      return r;
    }

    /* ── consent, then (off the landing) the sample: a stable 0–99 bucket per browser, kept after consent only ── */
    /* 20 Oct: quick iPhone bounces left before Shopify's privacy API loaded, so consented views went unrecorded (b6: pdp
       coverage 67%). Until the API exists, read Shopify's own consent cookie (_tracking_consent, the record the API
       itself reads): purposes.a, else con.CMP.a. No cookie or no analytics = no. Once the API loads it decides. */
    function cookieOk() {
      try {
        var m = (D.cookie || '').match(/(?:^|; )_tracking_consent=([^;]*)/); if (!m) return false;
        var j = JSON.parse(decodeURIComponent(m[1]));
        if (!j || j.display_banner === true) return false; /* banner still showing = no decision yet */
        if (j.purposes && typeof j.purposes.a === 'boolean') return j.purposes.a === true;
        var c = j && j.con && j.con.CMP; return !!(c && c.a === '1');
      } catch (e) { return false; }
    }
    function ok() {
      try { var c = W.Shopify && W.Shopify.customerPrivacy; if (c && typeof c.analyticsProcessingAllowed === 'function') return c.analyticsProcessingAllowed() === true; } catch (e) { return false; }
      return cookieOk();
    }
    var SMP = -1;
    function inSample() {
      if (SMP < 0) {
        SMP = 1;
        if (!LPM && SAMPLE < 100) {
          var b = -1;
          try { b = parseInt(W.localStorage.getItem('hgn:rec:b'), 10); if (!(b >= 0 && b < 100)) { b = Math.floor(Math.random() * 100); W.localStorage.setItem('hgn:rec:b', String(b)); } } catch (e) { b = Math.floor(Math.random() * 100); }
          SMP = b < SAMPLE ? 1 : 0;
        }
      }
      return SMP === 1;
    }
    var polls = 0, lf = 0, pollT = 0;
    var gate = sf(function (ev) { if (!REC && ok() && inSample()) start(ev === 1); });
    on(D, 'visitorConsentCollected', function () { setTimeout(function () { gate(1); }, 0); });
    pollT = setInterval(sf(function () {
      if (REC || ++polls > 40) { clearInterval(pollT); return; }
      var S = W.Shopify;
      if (polls === 6 && S && !S.customerPrivacy && typeof S.loadFeatures === 'function' && !lf) {
        lf = 1;
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { gate(0); });
      }
      gate(0);
    }), 500);

    /* ── identity: sc (Shopify's browser id) else cid (_hgn_cid), as hgn-lp-arm's ident() and the pixel. Read only. ── */
    var IDV = /^[A-Za-z0-9_\-.]{8,64}$/, SCV = /^[A-Za-z0-9_\-.]{8,80}$/;
    function ck(n) { var m = (D.cookie || '').match(new RegExp('(?:^|; )' + n + '=([^;]*)')); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
    function stY() {
      try { var st = (P.getEntriesByType('navigation')[0] || {}).serverTiming || []; for (var i = 0; i < st.length; i++) if (st[i].name === '_y') return String(st[i].description || ''); } catch (e) {}
      return '';
    }
    function ids() {
      var s = ck('_shopify_y'); if (!SCV.test(s)) { s = stY(); if (!SCV.test(s)) s = ''; }
      var c = ck('_hgn_cid'); if (!IDV.test(c)) c = '';
      return { sc: s, cid: c, idk: s ? 'sc:' + s : c ? 'cid:' + c : '' };
    }

    /* ── visibility: IntersectionObserver keeps who is on screen; the rule (≥50% of the element, or ≥30% of the
       viewport) is measured for those only, on a 1 s tick and on scroll. ── */
    var REG = [], io = null, tio = null, lastScan = -1e9, tickT = 0, sendT = 0, early = 0;
    function scan() {
      lastScan = T();
      var i, j, k, list, e;
      for (i = REG.length - 1; i >= 0; i--) if (!REG[i].e.isConnected) { if (io) io.unobserve(REG[i].e); REG.splice(i, 1); }
      var defs = OV.concat(PG);
      for (i = 0; i < defs.length; i++) {
        list = qa(defs[i][1]);
        for (j = 0; j < list.length; j++) {
          e = list[j]; k = defs[i][0];
          if (e['__hgnS' + k]) continue;
          e['__hgnS' + k] = 1;
          REG.push({ k: k, e: e, o: defs[i][3] !== undefined ? defs[i] : null });
          if (io) io.observe(e);
        }
      }
      if (tio && GRIDS) { list = qa(GRIDS); for (j = 0; j < list.length; j++) if (!list[j].__hgnU) { list[j].__hgnU = 1; tio.observe(list[j]); } }
    }
    function calc() {
      var vw = W.innerWidth || H.clientWidth, vh = W.innerHeight || H.clientHeight, now = {}, cover = 0, i, r, e, a, b, w, h;
      for (i = 0; i < REG.length; i++) {
        r = REG[i]; e = r.e;
        if (r.o) { if (r.o[2](e)) { now[r.k] = 1; if (r.o[3]) cover = 1; } continue; }
        if (now[r.k] || e.__hgnJ === 0) continue;
        b = e.getBoundingClientRect();
        w = Math.max(0, Math.min(b.right, vw) - Math.max(b.left, 0)); h = Math.max(0, Math.min(b.bottom, vh) - Math.max(b.top, 0));
        a = b.width * b.height;
        if (a > 0 && w * h > 0 && (w * h / a >= 0.5 || w * h >= 0.3 * vw * vh)) now[r.k] = 2;
      }
      if (cover) for (i in now) if (now[i] === 2) delete now[i]; /* a covering overlay pauses the page under it */
      return now;
    }
    var tick = sf(function () {
      var t = T(), dt = t - lastT, k;
      lastT = t;
      if (visible && dt > 0) {
        TOP += dt;
        for (k in VIS) if (SEC[k]) SEC[k][0] += dt;
      }
      if (!REC) return; /* before consent only the time on page moves: nothing is read from the page */
      if (t - lastScan > 2000) scan();
      VIS = calc();
      for (k in VIS) if (!SEC[k]) SEC[k] = [0, t];
      var y = W.pageYOffset || H.scrollTop || 0, vh = W.innerHeight || H.clientHeight, sh = Math.max(H.scrollHeight, D.body ? D.body.scrollHeight : 0);
      if (y + vh > MAXY) MAXY = Math.round(y + vh);
      if (sh > 0) SCR = Math.max(SCR, Math.min(100, Math.round(100 * (y + vh) / sh)));
    });
    var lastScroll = 0;
    function onScroll() { var t = T(); if (t - lastScroll > 250) { lastScroll = t; tick(); } }

    /* ── v1.3 visibility, site pages only (NV; the landing keeps scan/calc/tick above, frozen). The same rule, read from
       IntersectionObserver entries instead of a layout read each second: visible = at least 50% of the element in view,
       or the part in view covering at least 30% of the viewport (intersectionRect area / the IO root's area). Both halves
       reduce to one ratio, min(0.5, 0.3 × viewport area / element area), so each section gets its own observer with that
       threshold and the entry arrives exactly when its state flips. A ResizeObserver re-arms it when the section's size
       changes (and a resize when the viewport does); every entry re-checks its own threshold. Sections are rescanned only
       after elements are added to the page (≤ every 2 s, in idle time), and the 1 s bookkeeping runs in idle time. ── */
    var VA = 0, ro = null, smo = null, sDirty = 1, tq = 0, dq = 0, PZ = 0, TL = [];
    function idle(f) { try { if (W.requestIdleCallback) return W.requestIdleCallback(f, { timeout: 1000 }); } catch (e) {} return setTimeout(f, 0); }
    function thrOf(a) { return a > 0 && VA > 0 ? Math.min(0.5, 0.3 * VA / a) : 0.5; }
    function off(r) { return Math.abs(thrOf(r.a) - r.thr) > r.thr * 0.01; }
    function seen(r, x) {
      var b = x.boundingClientRect, q = x.intersectionRect, rb = x.rootBounds, ia;
      if (rb && rb.width * rb.height > 0) VA = rb.width * rb.height;
      r.a = b.width * b.height;
      ia = x.isIntersecting ? q.width * q.height : 0;
      r.v = r.a > 0 && ia > 0 && (ia / r.a >= 0.5 || ia >= 0.3 * VA) ? 1 : 0;
      if (!PZ && off(r)) watch(r);
    }
    function watch(r) { /* (re)arm one section's observer at the ratio where its visibility flips */
      if (r.io) r.io.disconnect();
      r.thr = thrOf(r.a);
      r.io = new IntersectionObserver(sf(function (es) { for (var i = 0; i < es.length; i++) seen(r, es[i]); tick2(0); }), { threshold: [0, r.thr] });
      r.io.observe(r.e);
    }
    function unwatch(r) {
      var rs = r.e.__hgnRs || [], i = rs.indexOf(r);
      if (r.io) r.io.disconnect();
      r.io = null; r.v = 0;
      if (i >= 0) rs.splice(i, 1);
      if (!rs.length && ro) ro.unobserve(r.e);
      r.e['__hgnS' + r.k] = 0;
    }
    function scan2() {
      lastScan = T(); sDirty = 0;
      var i, j, k, list, e, r, defs = OV.concat(PG);
      for (i = REG.length - 1; i >= 0; i--) if (!REG[i].e.isConnected) { if (!REG[i].o) unwatch(REG[i]); else REG[i].e['__hgnS' + REG[i].k] = 0; REG.splice(i, 1); }
      for (i = 0; i < defs.length; i++) {
        list = qa(defs[i][1]);
        for (j = 0; j < list.length; j++) {
          e = list[j]; k = defs[i][0];
          if (e['__hgnS' + k]) continue;
          e['__hgnS' + k] = 1;
          r = { k: k, e: e, o: defs[i][3] !== undefined ? defs[i] : null, v: 0, a: 0, thr: 0.5, io: null };
          REG.push(r);
          if (r.o) continue; /* overlays: their own open state, read in calc2 (no geometry) */
          if (!e.__hgnRs) e.__hgnRs = [];
          e.__hgnRs.push(r);
          if (!PZ) { watch(r); if (e.__hgnRs.length === 1) robs(e); }
        }
      }
      if (tio && GRIDS) {
        for (j = TL.length - 1; j >= 0; j--) if (!TL[j].isConnected) TL.splice(j, 1);
        list = qa(GRIDS); for (j = 0; j < list.length; j++) if (!list[j].__hgnU) { list[j].__hgnU = 1; TL.push(list[j]); if (!PZ) tio.observe(list[j]); }
      }
    }
    /* a covering overlay (side cart, popup, open filter drawer, zoom, quick view) pauses the sections under it, so their
       observers stop too: while any of ours is armed, a page animating under an overlay keeps the browser running a main-
       thread frame and recomputing every intersection observer on the page each frame (lab, side cart open: 23-39 ms/s at
       CPU 4x, 0 without the recorder). Re-armed on close: fresh entries give the exact state back. */
    function robs(e) { try { ro.observe(e, { box: 'border-box' }); } catch (x) { ro.observe(e); } }
    function pause(on) {
      if (on === PZ) return;
      PZ = on;
      if (on && ro) ro.disconnect();
      for (var i = 0, r; i < REG.length; i++) {
        r = REG[i]; if (r.o) continue;
        if (on) { if (r.io) r.io.disconnect(); r.io = null; }
        else { watch(r); if (ro && r.e.__hgnRs && r.e.__hgnRs[0] === r) robs(r.e); }
      }
      if (tio) { if (on) tio.disconnect(); else for (i = 0; i < TL.length; i++) if (TL[i].isConnected) tio.observe(TL[i]); }
    }
    function calc2() {
      var now = {}, cover = 0, i, r;
      for (i = 0; i < REG.length; i++) {
        r = REG[i];
        if (r.o) { if (r.o[2](r.e)) { now[r.k] = 1; if (r.o[3]) cover = 1; } continue; }
        if (r.v && !now[r.k] && r.e.isConnected) now[r.k] = 2;
      }
      if (cover) for (i in now) if (now[i] === 2) delete now[i]; /* a covering overlay pauses the page under it */
      pause(cover);
      return now;
    }
    function depth() { /* scroll % and the deepest bottom: read after a scroll settles (idle), on a send and on hide */
      var y = W.pageYOffset || H.scrollTop || 0, vh = W.innerHeight || H.clientHeight, sh = Math.max(H.scrollHeight, D.body ? D.body.scrollHeight : 0);
      if (y + vh > MAXY) MAXY = Math.round(y + vh);
      if (sh > 0) SCR = Math.max(SCR, Math.min(100, Math.round(100 * (y + vh) / sh)));
    }
    var tick2 = sf(function (full) {
      var t = T(), dt = t - lastT, k;
      lastT = t;
      if (visible && dt > 0) {
        TOP += dt;
        for (k in VIS) if (SEC[k]) SEC[k][0] += dt;
      }
      if (!REC) return; /* before consent only the time on page moves: nothing is read from the page */
      VIS = calc2();
      for (k in VIS) if (!SEC[k]) SEC[k] = [0, t];
      if (full) depth();
    });
    /* the 1 s tick, site pages: bookkeeping (and a rescan when elements were added) in idle time */
    var itick = function () {
      if (tq) return;
      tq = 1;
      idle(sf(function () { tq = 0; if ((sDirty || !smo) && T() - lastScan > 2000) scan2(); tick2(0); }));
    };
    function onScroll2() { if (dq) return; dq = 1; setTimeout(function () { idle(sf(function () { dq = 0; depth(); })); }, 250); }
    function TK(full) { if (NV) tick2(full); else tick(); } /* a full tick: on start, before each send and on hide */

    /* ── taps: one delegated passive capture listener; coordinates stay in memory for rage and swipe only ── */
    var down = null, recent = [], burst = 0, pend = [], moOn = 0;
    function interactive(e) { return !!cl(e, INTER) || mt(e, BACKDROP) || (!!SCRIM && mt(e, SCRIM)); }
    function noopable(e) {
      var x = cl(e, INTER);
      if (!x || mt(x, 'input,select,textarea,label,[disabled],video,audio') || cl(e, 'label')) return false;
      if (!LPM && mt(x, '[type=submit]') && cl(x, 'form[action*="/search"]')) return false; /* a search submit navigates */
      return !(mt(x, 'a[href]') && !/^(#|javascript:|$)/i.test(at(x, 'href')));
    }
    var IGN = 'head,script,style,link,iframe,noscript,meta,[data-hgn-ka-at],.hgn-kit-countdown,[data-hgn-side-cart-timer]';
    /* v2026-10-20.1: the tapped element's first class token (the element itself or its nearest classed ancestor, up
       to 4 levels), slugged: a code token such as hgn-side-cart__bundle-head, never text. v1.3: also the largest layout
       shift's source (cls_src), and Shopify's wrapper class on every section (shopify-section) is skipped like the
       state classes, so a section names itself (hgn-hero-section); v1.3.1 also skips Shopify's per-section id classes
       (section-template-<id>__…), which never aggregate */
    function ctok(e) {
      for (var i = 0, c; e && e.nodeType === 1 && e !== H && e !== D.body && i < 4; e = e.parentElement, i++) {
        c = typeof e.className === 'string' ? e.className.split(/\s+/) : [];
        for (var j = 0; j < c.length; j++) if (c[j] && !/^(is-|js-|hgn-scope$|scroll-trigger|animate--|color-|gradient$|shopify-section$|section-template-)/.test(c[j])) return slug(c[j]);
      }
      return '';
    }
    function real(n) { return n.nodeType === 1 ? !cl(n, IGN) : n.nodeType === 3 && /\S/.test(n.nodeValue || ''); }
    function effect() { pend = []; if (moOn) { mo.disconnect(); moOn = 0; } }
    var mo = W.MutationObserver ? new MutationObserver(sf(function (list) {
      for (var i = 0, m, j; i < list.length; i++) {
        m = list[i];
        if (cl(m.target.nodeType === 1 ? m.target : m.target.parentNode, IGN)) continue;
        if (m.type !== 'childList') return effect();
        for (j = 0; j < m.addedNodes.length; j++) if (real(m.addedNodes[j])) return effect();
        for (j = 0; j < m.removedNodes.length; j++) if (real(m.removedNodes[j])) return effect();
      }
    })) : null;
    on(W, 'scroll', function () { if (pend.length) effect(); }, { passive: true, capture: true });
    on(W, 'pagehide', effect); on(W, 'beforeunload', effect); on(D, 'visibilitychange', effect);
    var noopCheck = sf(function () {
      var t = T();
      pend = pend.filter(function (p) { if (t < p.d) return true; if (p.tp.k === 'ok') p.tp.k = 'noop'; return false; });
      if (!pend.length) effect();
    });
    /* v1.3: an event's own time on the performance clock (the Event Timing entries' clock), else now */
    function ets(ev) { var s = ev && ev.timeStamp, n = T(); return s > 0 && s <= n + 50 && s > n - 60000 ? s : n; }
    var tap = sf(function (e, x, y, swipe, t0, t1) {
      if (!REC) return;
      if (e && e.nodeType !== 1) e = e.parentElement;
      if (!e) return;
      /* v2026-10-21.2, site pages only: a press on the page itself (<html> or <body>: the desktop background beside the
         content, or the scrollbar track, whose clicks fire pointerdown/up on the root) is not a tap on anything (b6, 21 Oct:
         30 dead/rage taps from one desktop view all read v=js, the root's class). The landing is frozen as before. */
      if (!LPM && (e === H || e === D.body)) return;
      var t = T(), m = label(e, swipe), s = secOf(e), k = swipe || interactive(e) ? 'ok' : 'dead', i, near = 0, tp;
      NT++;
      lastTapT = t;
      if (TTFT < 0) TTFT = t;
      if (!m.l) m.l = s;
      if (!swipe) {
        recent = recent.filter(function (r) { return t - r.t <= 800; });
        for (i = 0; i < recent.length; i++) if (Math.abs(recent[i].x - x) <= 30 && Math.abs(recent[i].y - y) <= 30) near++;
        recent.push({ x: x, y: y, t: t });
        if (near >= 2) { if (burst) return; burst = 1; k = 'rage'; } else burst = 0;
      }
      if (!LPM && k !== 'ok' && !m.v) m.v = ctok(e);
      tp = { l: m.l, s: s, i: m.i, v: m.v, t: t, k: k };
      if (TAPS.length < 50) TAPS.push(tp);
      if (!LPM) { TT.push([t0 === undefined ? t : t0, t1 === undefined ? t : t1, m.l]); if (TT.length > 100) TT.shift(); } /* every recorded tap, past the 50 cap too */
      if (k === 'ok' && !swipe && noopable(e)) {
        pend.push({ tp: tp, d: t + 1000 });
        if (mo && !moOn) { mo.observe(H, { subtree: true, childList: true, attributes: true, characterData: true }); moOn = 1; }
        setTimeout(noopCheck, 1010);
      }
      var a = cl(e, 'a[href]');
      if (NAVL[m.l] || (a && !/^(#|javascript:|$)/i.test(at(a, 'href')))) lastNav = { l: m.l, t: t };
      if (m.l === 'filter_sort') lastSort = tp;
      if (m.l === 'search_submit') lastSS = t;
    });
    var lastSort = null;
    on(D, 'change', sf(function (ev) { /* the sort picked (an option value from the markup) */
      var e = ev.target;
      if (REC && lastSort && mt(e, 'select') && T() - lastSort.t < 60000) lastSort.v = slug(e.value);
    }), true);
    /* a search sent with the keyboard (Enter): the event only, never the term */
    if (!LPM) on(D, 'submit', sf(function (ev) {
      var f = ev.target, t = T();
      if (!REC || !mt(f, 'form[action*="/search"]') || t - lastSS < 1500) return;
      NT++; lastSS = t; lastTapT = t; if (TTFT < 0) TTFT = t;
      if (TAPS.length < 50) TAPS.push({ l: 'search_submit', s: secOf(f), i: 0, v: '', t: t, k: 'ok' });
      TT.push([ets(ev), ets(ev), 'search_submit']); if (TT.length > 100) TT.shift();
      lastNav = { l: 'search_submit', t: t };
    }), true);
    if (W.PointerEvent) {
      on(D, 'pointerdown', sf(function (ev) { if (ev.isPrimary !== false) down = { x: ev.clientX, y: ev.clientY, e: ev.target, id: ev.pointerId, ts: LPM ? 0 : ets(ev) }; }), { capture: true, passive: true });
      on(D, 'pointercancel', function () { down = null; }, { capture: true, passive: true });
      on(D, 'pointerup', sf(function (ev) {
        var d = down; down = null;
        if (!d || d.id !== ev.pointerId) return;
        var dx = ev.clientX - d.x, dy = ev.clientY - d.y, u = LPM ? 0 : ets(ev);
        if (Math.abs(dx) < 12 && Math.abs(dy) < 12) tap(d.e, ev.clientX, ev.clientY, 0, d.ts, u);
        else if (Math.abs(dx) > 30 && Math.abs(dx) > 1.5 * Math.abs(dy)) {
          if (cl(d.e, '.hgn-card__media,.card__media')) tap(d.e, 0, 0, 1, d.ts, u);
          else if (!LPM && cl(d.e, 'media-gallery')) tap(d.e, 0, 0, 2, d.ts, u);
        }
      }), { capture: true, passive: true });
    } else {
      on(D, 'click', sf(function (ev) { var u = LPM ? 0 : ets(ev); tap(ev.target, ev.clientX, ev.clientY, 0, u, u); }), { capture: true, passive: true });
    }

    /* ── kit and cart, from the events the page already fires ── */
    on(D, 'hgn:kit-build-mode:change', sf(function (ev) { var d = ev.detail || {}; if (REC && d.to === 'on' && d.from !== 'on') KS = 1; }));
    on(D, 'hgn:kit:change', sf(function (ev) { if (REC && (ev.detail || {}).action === 'add') KP++; }));
    function added(viaNet) {
      var t = T();
      if (!REC || (viaNet && t - lastTapT > 10000)) return;
      if (t - lastAdd > 3000) ATC++;
      lastAdd = t;
    }
    on(D, 'hgn:side-cart:add', sf(function () { added(0); }));
    on(D, 'cart:update', sf(function () { added(0); }));

    /* ── speed ── */
    /* v1.3.2: returns the observer (0 when unsupported); DRAIN keeps [observer, callback] for the hide-time flush */
    var DRAIN = [];
    function po(type, f, o, keep) {
      try {
        if (!W.PerformanceObserver || (PerformanceObserver.supportedEntryTypes || []).indexOf(type) < 0) return 0;
        var ob = new PerformanceObserver(sf(function (l) { l.getEntries().forEach(f); }));
        ob.observe(o || { type: type, buffered: true });
        if (keep) DRAIN.push([ob, f]);
        return ob;
      } catch (e) { return 0; }
    }
    /* v1.3.2: deliver what the browser has queued but not yet handed over, in DRAIN's order (shift, frame, event) */
    function drain() {
      for (var i = 0; i < DRAIN.length; i++) { try { DRAIN[i][0].takeRecords().forEach(DRAIN[i][1]); } catch (e) {} }
    }
    var sw = 0, sv = 0, s1 = 0, s9 = 0;
    function clampI(n, lo, hi) { n = Math.round(n); return n < lo ? lo : n > hi ? hi : n || 0; }
    /* v1.3: the largest single shift's source. Of its moved elements (≤5), the largest now (currentRect area), preferring
       one the browser still names; cls_src = that element's first class token, as a dead tap's v (its tag when no
       ancestor within 4 levels has a class); cls_dy = px it moved down (− = up); cls_t = when; cls_y = scrollY when the
       entry was delivered (within a frame of the shift; for a shift before recording began, the scroll position then). */
    function shiftSrc(e) {
      var ss = e.sources || [], b = null, bn = null, i, x, a, an = -1, aa = -1, n;
      for (i = 0; i < ss.length; i++) {
        x = ss[i];
        a = x.currentRect ? x.currentRect.width * x.currentRect.height : 0;
        if (!(a > 0) && x.previousRect) a = x.previousRect.width * x.previousRect.height / 1e7;
        if (a > aa) { aa = a; b = x; }
        if (x.node && a > an) { an = a; bn = x; }
      }
      CLSBIG = Math.max(CLSBIG, e.value);
      CLST = clampI(e.startTime, 0, 86400000);
      CLSY = clampI(W.pageYOffset || H.scrollTop || 0, 0, 10000000);
      b = bn || b; CLSS = ''; CLSDY = null;
      if (!b) return;
      if (b.currentRect && b.previousRect) CLSDY = clampI(b.currentRect.y - b.previousRect.y, -10000, 10000);
      n = b.node;
      if (n && n.nodeType !== 1) n = n.parentElement;
      if (n && n.nodeType === 1) CLSS = ctok(n) || slug(n.tagName);
    }
    /* v1.3: a script's file as a token: hgn-kit-bar.js, load_feature.js; page scripts → inline; no file name → the host */
    function stok(u) {
      u = String(u || '');
      var m = /^(?:https?:)?\/\/([^\/?#]+)([^?#]*)/i.exec(u), h, p, f, d;
      if (!m) return !u || /^(blob|data):/i.test(u) ? 'inline' : 'other';
      h = m[1].toLowerCase(); p = m[2]; f = p.slice(p.lastIndexOf('/') + 1).toLowerCase();
      try { f = decodeURIComponent(f); } catch (x) {}
      if (!/\.m?js$/.test(f)) return h === String(L.hostname).toLowerCase() ? 'inline' : slug(h.replace(/^www\./, '')) || 'other';
      f = f.replace(/\.min(?=\.m?js$)/, '').replace(/[-_.@]v?\d+(?:\.\d+)+(?=\.m?js$)/, '').replace(/[-_.~](?=[0-9a-f]*\d)[0-9a-f]{7,}(?=\.m?js$)/, '');
      if (/^[a-z0-9]{16,}\.m?js$/.test(f) && /\d/.test(f)) { d = p.slice(0, p.lastIndexOf('/')); f = (d.slice(d.lastIndexOf('/') + 1) || h) + '.js'; } /* a hash name: its folder */
      return slug(f) || 'other';
    }
    /* v1.3: a long animation frame overlapping the worst interaction: its longest script wins (a frame with none = render) */
    function lfAt(f) {
      if (!IW || f[0] >= IW[1] || f[1] <= IW[0]) return;
      if (f[2]) { if (f[2][1] > INPD) { INPS = f[2][0]; INPD = f[2][1]; INPFL = f[2][2]; } }
      else if (!INPS) { INPS = 'render'; INPD = 0; INPFL = -1; }
    }
    /* v1.3.2: the worst interaction's own target, labelled the moment its entry arrives (a re-rendered chip would be gone
       by send time): inp_l's fallback when no recorded tap lies within 1 s of it, e.g. a tap made before this script
       loaded (b6, 23 Oct: 11 of 13 slow collection views had a worst tap the recorder never saw) */
    var IWL = '';
    function worst(e) {
      IW = [e.startTime, e.startTime + e.duration]; INPS = ''; INPD = -1; INPFL = -1; IWL = '';
      try { var x = e.target; if (x && x.nodeType !== 1) x = x.parentElement; if (x && x !== H && x !== D.body) { var m = label(x, 0); IWL = m.l || secOf(x); } } catch (er) { IWL = ''; }
      for (var i = 0; i < LF.length; i++) lfAt(LF[i]);
    }
    /* v1.3: the label of the recorded tap nearest the worst interaction's start (0 when it falls between its down and up), ≤1 s */
    function inpL() {
      if (!IW) return '';
      for (var i = 0, s = IW[0], d, x, best = 1001, l = ''; i < TT.length; i++) {
        x = TT[i]; d = s < x[0] ? x[0] - s : s > x[1] ? s - x[1] : 0;
        if (d < best) { best = d; l = x[2]; }
      }
      if (best <= 1000 && /^[a-z][a-z0-9_]{0,23}$/.test(l)) return l;
      return IWL && IWL !== 'none' && /^[a-z][a-z0-9_]{0,23}$/.test(IWL) ? IWL : ''; /* v1.3.2: the entry's own target */
    }
    function speed() {
      po('largest-contentful-paint', function (e) { LCP = Math.round(e.startTime); });
      if (po('layout-shift', function (e) {
        if (e.hadRecentInput) return;
        if (sw && e.startTime - s9 < 1000 && e.startTime - s1 < 5000) { sv += e.value; } else { sv = e.value; s1 = e.startTime; sw = 1; }
        s9 = e.startTime;
        if (sv > CLS) CLS = sv;
        if (!LPM && CLSBIG < e.value) shiftSrc(e);
      }, null, !LPM)) { if (CLS < 0) CLS = 0; } /* v1.3.2: kept for the drain on site pages only (the landing's paths stay as v1.3.1) */
      var ev = function (e) { if (e.interactionId && e.duration > INP) { INP = Math.round(e.duration); if (!LPM) worst(e); } };
      /* v1.3.2: frames before events in DRAIN, so a drained worst tap finds its frames already in LF */
      if (!LPM) po('long-animation-frame', function (f) {
        var ss = f.scripts || [], b = null, i;
        for (i = 0; i < ss.length; i++) if (!b || ss[i].duration > b.duration) b = ss[i];
        var r = [f.startTime, f.startTime + f.duration, b ? [stok(b.sourceURL), b.duration, clampI(b.forcedStyleAndLayoutDuration || 0, 0, 60000)] : null];
        LF.push(r); if (LF.length > 50) LF.shift();
        lfAt(r);
      }, null, 1);
      po('event', ev, { type: 'event', buffered: true, durationThreshold: 16 }, !LPM);
      po('resource', function (e) { if (/\/cart\/add/.test(e.name)) added(1); }, { type: 'resource' });
    }

    /* ── transport: the whole state, rising seq, ≤8 KB, beacon then keepalive fetch, silent on any failure ── */
    function exitNow() {
      var e = null;
      try { e = D.elementFromPoint((W.innerWidth || 0) / 2, (W.innerHeight || 0) / 2); } catch (x) {}
      EXIT = e ? secOf(e) : 'none';
      OUT = lastNav && T() - lastNav.t <= 5000 ? lastNav.l : 'none';
    }
    /* "changed since the last send" (off the landing): what a row would show, not the clock */
    function sig() {
      var n = 0, k;
      for (k in SEC) n++;
      return [NT, TAPS.map(function (t) { return t.k.charAt(0); }).join(''), n, SCR, MAXY, TILES, KS, KP, ATC, LCP, CLS < 0 ? -1 : Math.round(CLS * 1000), INP,
        inpL(), INPS, INPFL, CLSS, CLSDY, CLST, CLSY].join(); /* v1.3: the attribution fields move it too (sig is off the landing only) */
    }
    function send(fin) {
      if (!REC || GONE || SENDS >= 240 || (LPM && (!EXP || !KEY)) || !ok()) return;
      var id = ids();
      if (!id.idk) return;
      SEQ++; SENDS++;
      var o = { v: 1, pv: PV, seq: SEQ, final: fin ? 1 : 0, idk: id.idk, cid: id.cid, sc: id.sc, wd: N.webdriver ? 1 : 0, pin: PIN };
      if (LPM) { o.exp = EXP; o.arm = ARM; o.variant = KEY; o.coll = COLL; } else if (COLL) o.coll = COLL;
      o.page = PAGE;
      if (!LPM) { if (HANDLE) o.handle = HANDLE; if (TPL) o.tpl = TPL; LASTSIG = sig(); }
      o.vw = Math.round(W.innerWidth || 0); o.vh = Math.round(W.innerHeight || 0); o.iab = IAB; o.os = OS; o.c0 = C0; o.sec = SEC; o.scroll = SCR;
      o.maxy = MAXY; o.tiles = TILES; o.taps = TAPS.slice(0, 50); o.nt = NT; o.ttft = TTFT; o.top = Math.round(TOP); o.exit = EXIT; o.out = OUT;
      o.kit = { s: KS, p: KP }; o.atc = ATC; o.lcp = LCP; o.cls = CLS < 0 ? -1 : Math.round(CLS * 1000); o.inp = INP;
      if (!LPM) { /* v1.3: on every send once known (each send replaces the row's values); absent until then */
        var il = inpL();
        if (il) o.inp_l = il;
        if (INPS) o.inp_s = INPS;
        if (INPS && INPFL >= 0) o.inp_fl = INPFL;
        if (CLSS) o.cls_src = CLSS;
        if (CLSDY !== null) o.cls_dy = CLSDY;
        if (CLST >= 0) { o.cls_t = CLST; o.cls_y = CLSY; }
      }
      var s = JSON.stringify(o);
      while (s.length > 8000 && o.taps.length) { o.taps = o.taps.slice(0, o.taps.length - 5); s = JSON.stringify(o); }
      try { if (N.sendBeacon && N.sendBeacon(EP, new Blob([s], { type: 'text/plain' }))) return; } catch (e) {}
      try { W.fetch(EP, { method: 'POST', body: s, keepalive: true, mode: 'no-cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' } })['catch'](function () {}); } catch (e) {}
    }
    function loop() {
      clearInterval(tickT); clearInterval(sendT);
      if (!visible || !REC) return;
      tickT = setInterval(NV ? itick : tick, 1000);
      sendT = setInterval(sf(function () { TK(1); if (LPM || sig() !== LASTSIG) send(0); }), EVERY);
      if (!early) { early = 1; setTimeout(sf(function () { if (visible && SEQ === 0) { TK(1); send(0); } }), Math.min(5000, EVERY)); }
    }
    var hide = sf(function (fin) { TK(1); if (REC) { if (!LPM) drain(); exitNow(); send(fin); } }); /* v1.3.2: drain before the send (site pages; the landing stays frozen) */

    /* ── start: consent given (and, off the landing, in the sample) ── */
    function start(byEvent) {
      if (REC) return;
      TK(0);
      REC = 1;
      C0 = byEvent ? T() : 0;
      clearInterval(pollT);
      if (!LPM && !PIN) try { if (/^harness-/.test(W.localStorage.getItem('hgn:did') || '')) PIN = 1; } catch (e) {}
      if (NV) try { /* v1.3, site pages: per-section observers (watch), re-armed on resize; rescans after added elements */
        ro = new ResizeObserver(sf(function (es) {
          for (var i = 0, j, x, rs, z, a; i < es.length; i++) {
            x = es[i]; rs = x.target.__hgnRs || [];
            z = x.borderBoxSize && (x.borderBoxSize[0] || x.borderBoxSize);
            a = z && z.inlineSize >= 0 ? z.inlineSize * z.blockSize : x.contentRect.width * x.contentRect.height;
            for (j = 0; j < rs.length; j++) { rs[j].a = a; if (!PZ && off(rs[j])) watch(rs[j]); }
          }
        }));
        if (W.MutationObserver) {
          smo = new MutationObserver(sf(function (list) {
            if (sDirty) return;
            for (var i = 0, j, a; i < list.length; i++) for (a = list[i].addedNodes, j = 0; j < a.length; j++) if (a[j].nodeType === 1 && !mt(a[j], 'script,style,link,meta,noscript')) { sDirty = 1; return; }
          }));
        }
        on(W, 'resize', sf(function () { VA = (W.innerWidth || 0) * (W.innerHeight || 0) || VA; for (var i = 0; i < REG.length; i++) if (!PZ && !REG[i].o && REG[i].io && off(REG[i])) watch(REG[i]); }), { passive: true });
      } catch (e) { NV = false; ro = smo = null; }
      try {
        if (!NV) io = new IntersectionObserver(sf(function (es) { es.forEach(function (x) { x.target.__hgnJ = x.isIntersecting ? 1 : 0; }); onScroll(); }), { threshold: [0, 0.5, 1] });
        tio = new IntersectionObserver(sf(function (es) {
          es.forEach(function (x) { if (x.isIntersecting && x.intersectionRatio >= 0.5 && mt(x.target, TILE)) { var n = nth(x.target, TILE); if (n > TILES) TILES = n; } });
        }), { threshold: [0.5] });
      } catch (e) { io = tio = null; }
      /* off the landing the first measure waits a frame: reading layout before the browser's own first layout would
         force the whole page's layout inside this task (25-45 ms on the live pages offline; this script's own work is
         ~5 ms). The landing measures at once, as hgn-lp-recorder.js does (its early scroll % depends on it: parity). */
      var went = 0, go = sf(function () {
        if (went) return;
        went = 1;
        if (NV) { VA = (W.innerWidth || H.clientWidth) * (W.innerHeight || H.clientHeight); sf(scan2)(); if (smo) smo.observe(H, { childList: true, subtree: true }); }
        else sf(scan)();
        TK(1);
        sf(speed)();
        on(W, 'scroll', NV ? onScroll2 : onScroll, { passive: true });
        loop();
      });
      if (LPM) return go();
      try { W.requestAnimationFrame(function () { setTimeout(go, 0); }); } catch (e) {}
      setTimeout(go, 500); /* a page loaded in the background gets no frame */
    }
    on(D, 'visibilitychange', sf(function () {
      if (GONE) return;
      if (D.visibilityState === 'hidden') { hide(0); visible = false; loop(); }
      else { lastT = T(); visible = true; loop(); }
    }));
    on(W, 'pagehide', sf(function () { hide(1); GONE = 1; visible = false; loop(); }));
    on(W, 'pageshow', sf(function (ev) { if (ev.persisted) { GONE = 0; lastT = T(); visible = D.visibilityState !== 'hidden'; loop(); } }));
    gate(0);
  }
  try { main(); } catch (e) {}
})(window, document);
